import React from "react";
import { useNavigate } from "react-router-dom";
import { AUTH_STORAGE_KEY } from "../socket";
import "./FloatingSideButtons.css";

export default function FloatingSideButtons() {
  const navigate = useNavigate();

  const isLoggedIn = () => {
    try {
      return !!JSON.parse(localStorage.getItem(AUTH_STORAGE_KEY))?.token;
    } catch {
      return false;
    }
  };

  const handleClick = () => {
    if (isLoggedIn()) {
      navigate("/add-service"); // Change if needed
    } else {
      navigate("/login");
    }
  };

  return (
    <div
      className="gift-floating-wrapper"
      onClick={handleClick}
      title="Free Business Listing"
    >
      <div className="gift-badge">

        <div className="gift-new">FREE</div>

        <div className="gift-icon">
          🎁
        </div>

        <div className="gift-text">
          BUSINESS
          <br />
          LISTING
        </div>

      </div>
    </div>
  );
}